"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToken = void 0;
function getToken() {
    const { token: xpropsToken } = window.xprops || {};
    if (xpropsToken) {
        return xpropsToken;
    }
    const roleplayingToken = localStorage.getItem('StreamElements.roleplaying');
    if (roleplayingToken) {
        return roleplayingToken;
    }
    const cookie = document.cookie.match(/se-token=([^;]+)/);
    if (!cookie) {
        return null;
    }
    const [, token] = cookie;
    return token;
}
exports.getToken = getToken;
